import MainLayout from '@/layouts/Main.vue'
import MapLayout from '@/layouts/Map.vue'
// import { component } from 'vue/types/umd'

export default [
  {
    name: 'login',
    path: '/login',
    component: () => import('@/pages/auth/Login.vue'),
    meta: { auth: false }
  },
  {
	  component: MapLayout,
	  meta: { auth: true },
	  path: '/map',
	  children: [
		  {
			  name: 'map',
			  path: '/map',
			  props: { scheme: null, tenant: null },
			  component: () => import('@/pages/map/IndexNew.vue')
		  },
      ]
  },
  {
    path: '/',
    component: MainLayout,
    meta: { auth: true },
    children: [
      {
        name: 'my-properties',
        path: '',
        component: () => import('@/pages/IndexNew.vue')
      },
      {
        name: 'profile',
        path: 'profile',
        component: () => import('@/pages/auth/Profile.vue')
      },
      {
        name: 'notifications',
        path: 'notifications',
        component: () => import('@/pages/notifications/Index.vue'),
      },
      {
          name: 'core',
          path: 'core',
          component: () => import('@/pages/core/Index.vue'),
          meta: { auth: {type:'admin'} },
      },
      // users
      {
        name: 'users',
        path: 'users',
        component: () => import('@/pages/users/Index.vue')
      },
      {
        name: 'users.create',
        path: 'users/create',
        component: () => import('@/pages/users/Create.vue')
      },
      {
        name: 'users.edit',
        path: 'users/:id/edit',
        component: () => import('@/pages/users/Edit.vue')
      },
      // companies
      {
        name: 'companies',
        path: 'companies',
        component: () => import('@/pages/companies/Index.vue')
      },
      {
        name: 'companies.create',
        path: 'companies/create',
        component: () => import('@/pages/companies/Create.vue')
      },
      {
        name: 'companies.edit',
        path: 'companies/:id/edit',
        component: () => import('@/pages/companies/Edit.vue')
      },
      // schemes
      {
          name: 'schemes',
          path: 'schemes',
          component: () => import('@/pages/schemes/Index.vue')
      },
      {
          name: 'schemes.create',
          path: 'schemes/create',
          component: () => import('@/pages/schemes/Create.vue')
      },
      // {
      //   name: 'help',
      //   path: 'help',
      //   component: () => import('@/pages/help/Index.vue')
      // },
      {
        name: 'deals',
        path: 'deals',
        component: () => import('@/pages/deals/Index.vue')
      },
      // {
      //     name: 'schemes.edit',
      //     path: 'schemes/:id/edit',
      //     component: () => import('@/pages/schemes/Edit.vue')
      // },

      // properties
      {
          name: 'properties',
          path: 'properties',
          component: () => import('@/pages/properties/Index.vue')
      },
      {
          name: 'properties.create',
          path: 'properties/create',
          component: () => import('@/pages/properties/Create.vue')
      },
      {
        name: 'core.data',
        path: 'core-data',
        component: () => import('@/pages/core/data/Index.vue')
      },
      {
        name: 'reports.gap-analysis',
        path: 'reports/gap-analysis',
        component: () => import('@/pages/gapReport/Index.vue')
      },
      // {
      //   name: 'myProperties',
      //   path: 'my-properties',
      //   component: () => import('@/pages/myProperties/IndexNew.vue')

      // },
      {
        name: 'setMeAsLandlordContact',
        path: 'set-me-as-landlord-contact',
        component: () => import('@/pages/myProperties/SetMeAsLandlordContactWizard.vue')
      },
      {
        name: 'setMeAsTenantContact',
        path: 'set-me-as-tenant-contact',
        component: () => import('@/pages/myProperties/SetMeAsTenantContactWizard.vue')
      },
      // {
      //   name: 'saleDealWizard',
      //   path: 'sales-deal',
      //   component: () => import('@/pages/deals/saleDealWizard.vue')
      // },
      // {
      //   name: 'newLettingDealWizard',
      //   path: 'letting-deal',
      //   component: () => import('@/pages/deals/newLettingDealWizard.vue')
      // },
      // {
      //   name: 'subLettingDealWizard',
      //   path: 'sub-letting-deal',
      //   component: () => import('@/pages/deals/subLettingDealWizard.vue')
      // },
      // {
      //   name: 'rentReviewDealWizard',
      //   path: 'rent-review-deal',
      //   component: () => import('@/pages/deals/rentReviewDealWizard.vue')
      // },
      // {
      //   name: 'leaseRenewalDealWizard',
      //   path: 'lease-renewal-deal',
      //   component: () => import('@/pages/deals/leaseRenewalDealWizard.vue')
      // },
      // {
      //   name: 'tenantChangeDealWizard',
      //   path: 'tenant-change-deal',
      //   component: () => import('@/pages/deals/tenantChangeDealWizard.vue')
      // },
      {

        name: 'enquiries',
        path: 'enquiries',
        component: () => import('@/pages/enquiries/Index.vue')
      },

      // {
      //   name: 'testing',
      //   path: 'test',
      //   component: () => import('@/pages/test.vue')
      // },

      {
        name: 'pipelines',
        path: 'pipelines',
        component: () => import('@/pages/pipeline/Index.vue')
      },

      // {
      //     name: 'properties.edit',
      //     path: 'properties/:id/edit',
      //     component: () => import('@/pages/properties/Edit.vue')
      // },
      // map
      // {
      //     name: 'map',
      //     path: 'map',
		//   props: { scheme: null },
      //     component: () => import('@/pages/map/Index.vue')
      // },
      // ...other
      {
        name: 'access-error',
        path: 'access-error',
        component: () => import('@/pages/403.vue')
      },
      {
        path: '*',
        component: () => import('@/pages/404.vue')
      }
    ]
  }
]
